
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { defineStore } from "pinia";
// import { AuthService } from '@/composables/api/authService'
// import { useToastStore } from "@/store/useToastStore";
import { useAuthDataStore } from "@/store/useAuthDataStore";
import  { AuthService } from "@/composables/api/authService";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/notfound", name: "error404", component: () => import("@/views/errors/404.vue"),
        meta: { name: "Page not found", requiresAuth: false },
    },
    {
        path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/views/errors/404.vue"),
        redirect: { name: "error404" },
        children:[]
    },
    {
        path: "/unauthorized", name: "unauthorized", component: () => import("@/views/errors/401.vue"),
        meta: { name: "unauthorized", requiresAuth: false },
    },
    {
        path: "/forbidden", name: "forbidden", component: () => import("@/views/errors/403.vue"),
        meta: { name: "forbidden", requiresAuth: false },
    },
    {
        path: "/", name: "Login", component: () => import("@/login.vue"),
        meta: { title: "", name: "Login", requiresAuth: false, },
    },
    {
        path: "/Login/ResetPassword", name: "Reset Password", component: () => import("@/resetPassword.vue"),
        meta: { title: "", name: "Reset Password", requiresAuth: false, },
        props: (route) => ({ Id: route.query.Id }),
    },
    {
        path: "/home", name: "Home", components: {
            default: () => import("@/home.vue"),
            layout: () => import("@/components/shared/layout/defaultLayout.vue"),
        },
        meta: { title: "", name: "Home", requiresAuth: true,MainPage:'Home'  },
        redirect: { name: "Dashboard" },
        children: [
            {
                path: "/dashboard", name: "Dashboard", component: () => import("@/views/frontEnd/dashboard.vue"),
                meta: { title: "", name: "Dashboard", requiresAuth: true,MainPage:'Dashboard'  },
            },
            {
                path: "/master", name: "Master", component: () => import("@/views/frontEnd/master.vue"),
                meta: { title: "Crave Table App | Master", name: "Master", 
                requiresAuth: true,
                TabName:'master',
                MainPage:'Master'  },
                redirect: { name: "Category" },
                children: [
                    
                    {
                        path: "/master/category", name: "Category", component: () => import("@/views/frontEnd/master/category/category-list.vue"),
                        meta: { title: "Crave Table App | Master | Category", name: "Category", requiresAuth: true, children: [], 
                        TabName:'category',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/menu", name: "menu", component: () => import("@/views/frontEnd/master/menuItem/menuItem-list.vue"),
                        meta: { title: "Crave Table App | Master | Menu", name: "menu", requiresAuth: true, children: [], 
                        TabName:'menu',
                        MainPage:'Master' 
                        },
                    },
                    
                    {
                        path: "/master/contentmanage", name: "contentbullet", component: () => import("@/views/frontEnd/master/contentBullets/contentBullets-list.vue"),
                        meta: { title: "Crave Table App | Master | contentbullet", name: "contentbullet", requiresAuth: true, children: [], 
                        TabName:'contentbullet',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/gallerymedia", name: "gallerymedia", component: () => import("@/views/frontEnd/master/gallerymedia/gallerymedia-list.vue"),
                        meta: { title: "Crave Table App | Master | gallerymedia", name: "gallerymedia", requiresAuth: true, children: [], 
                        TabName:'gallerymedia',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/banner", name: "banner", component: () => import("@/views/frontEnd/master/banner/banner-list.vue"),
                        meta: { title: "Crave Table App | Master | banner", name: "banner", requiresAuth: true, children: [], 
                        TabName:'banner',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/sitesetting", name: "sitesetting", component: () => import("@/views/frontEnd/master/sitesetting/sitesetting-list.vue"),
                        meta: { title: "Crave Table App | Master | sitesetting", name: "sitesetting", requiresAuth: true, children: [], 
                        TabName:'sitesetting',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/bookingtype", name: "bookingtype", component: () => import("@/views/frontEnd/master/bookingtype/bookingtype-list.vue"),
                        meta: { title: "Crave Table App | Master | bookingtype", name: "bookingtype", requiresAuth: true, children: [], 
                        TabName:'bookingtype',
                        MainPage:'Master' 
                        },
                    },                   
                   
                    
                    {
                        path: "/master/banner", name: "banner", component: () => import("@/views/frontEnd/master/banner/banner-list.vue"),
                        meta: { title: "Yantra App | Master | banner", name: "banner", requiresAuth: true, children: [], 
                        TabName:'banner',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/sitesetting", name: "sitesetting", component: () => import("@/views/frontEnd/master/sitesetting/sitesetting-list.vue"),
                        meta: { title: "Yantra App | Master | sitesetting", name: "sitesetting", requiresAuth: true, children: [], 
                        TabName:'sitesetting',
                        MainPage:'Master' 
                        },
                    },
                    {
                        path: "/master/navmenu", name: "navmenu", component: () => import("@/views/frontEnd/master/navmenu/navmenu-list.vue"),
                        meta: { title: "Crave Table App | Master | navmenu", name: "navmenu", requiresAuth: true, children: [], 
                        TabName:'navmenu',
                        MainPage:'Master' 
                        },
                    },
                   
                   {
                         path: "/master/enquiryList",
            name: "enquiryList",
            component: () =>
              import("@/views/frontEnd/admintools/enquiryList/enquiryList.vue"),
                        meta: { title: "Crave Table App | Master | enquiryList", name: "enquiryList", requiresAuth: true, children: [], 
                        TabName:'enquiryList',
                        MainPage:'Master' 
                        },
                    },
                    
                ]
            },
           
            
          
          {
  path: "/admintools",
  name: "AdminTools",
  component: () => import("@/views/frontEnd/admintools.vue"),
  meta: {
    title: "EMS | Admin Tools",
    name: "AdminTools",
    requiresAuth: true,
    TabName: "admintools",
    MainPage: "AdminTools",
  },
  children: [
    {
      path: "users",
      name: "User",
      component: () =>
        import("@/views/frontEnd/admintools/users/user-list.vue"),
      meta: {
        title: "",
        name: "User",
        requiresAuth: true,
        MainPage: "AdminTools",
        TabName: "admintools",
        ModuleName: ["Roles&Permissions"],
        PageCode: ["User"],
      },
    },

    {
      path: "role",
      name: "Role",
      component: () =>
        import("@/views/frontEnd/admintools/roles/roles-list.vue"),
      meta: {
        title: "",
        name: "Role",
        requiresAuth: true,
        MainPage: "AdminTools",
        TabName: "admintools",
        ModuleName: ["Roles&Permissions"],
        PageCode: ["Role"],
      },
    },

    {
      path: "systemsetting",
      name: "SiteSetting",
      component: () =>
        import(
          "@/views/frontEnd/admintools/websetting/websiteSettings.vue"
        ),
      meta: {
        title: "",
        name: "SiteSetting",
        requiresAuth: true,
        MainPage: "AdminTools",
        TabName: "admintools",
        ModuleName: ["Setting"],
        PageCode: ["SiteSetting"],
      },
    },

    {
      path: "audit-logs",
      name: "AuditLogs",
      component: () =>
        import("@/views/frontEnd/admintools/auditLog/audit-log.vue"),
      meta: {
        title: "",
        name: "AuditLogs",
        requiresAuth: true,
        MainPage: "AdminTools",
        TabName: "admintools",
        ModuleName: ["AuditTrail"],
        PageCode: ["AuditTrail"],
      },
    },
  ],
}

                
        ],
    },      

];
const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const authLogin = useAuthDataStore().getAuth as any;    
    if (to.meta.requiresAuth) {
        let prm = true
        if((to?.meta?.MainPage ?? '') == 'Dashboard' && (authLogin?.Token ?? "").length > 0)
        {
            prm=true
        }
        return (authLogin?.Token ?? "").length == 0 ? next({ name: "Login", query: { redirect: to.fullPath, } }) : next();
    }
    else return next();
    

})
export default router;
